import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PeppolEInvoiceWaitingQueueContainerModel } from '../../../../../../models/aggregates/e-invoice/peppol/bl_ppl_einvoice_waiting_queue_container.model';
import { Observable } from 'rxjs';
import { ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config } from '../../shared';


@Injectable({
  providedIn: 'root'
})
export class WaitingQueuePostToProcessService extends BaseApiTemplateService<PeppolEInvoiceWaitingQueueContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.PEPPOL_PREFIX + 'waiting-queues';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + + Core2Config.ERP_PREFIX + Core2Config.PEPPOL_PREFIX + 'waiting-queues'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + + Core2Config.ERP_PREFIX + Core2Config.PEPPOL_PREFIX + 'waiting-queues'
    this.httpClient = http;
  }

  postMultipleToProcess(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + "/process-posting-queues/backoffice-ep";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

}
